export default __webpack_public_path__ + "static/media/icon-checkbox-input-checked-v2.8af88c4e.svg";